import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "shadow-xl grow-0 bg-next-gray-md-dark min-h-10 p-2 grid grid-cols-4 gap-2" }
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "text-sm text-right" }
const _hoisted_5 = { class: "text-sm text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createStaticVNode("<span class=\"col-span-4 text-center font-bold\">Riepilogo Fees</span><span class=\"text-sm font-bold\">Nome</span><span class=\"text-sm font-bold\">Valore</span><span class=\"text-sm font-bold text-right\">Budget imponibile</span><span class=\"text-sm font-bold text-right\">Budget lordo IVA</span><span class=\"col-span-4 border-b\"></span>", 6)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Fees, (f) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(f.nome), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(f.valore) + " %", 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString((f.valore * f.budget / 100).toLocaleValueString(2, 2)) + " €", 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString((f.valore * f.budget * 0.0122).toLocaleValueString(2, 2)) + " €", 1)
        ], 64))
      }), 256))
    ])
  ]))
}